/* eslint-disable @typescript-eslint/no-explicit-any */
import { SerializedStyles } from '@emotion/react';
import { Control, FieldValues } from 'react-hook-form';

export enum FieldTypes {
    Input,
    Select,
    Autocomplete,
    Phone,
    DateOfBirth,
    Password,
    Checkbox,
}

export enum TextFieldTypes {
    EMAIL = 'email',
    POSTCODE = 'postcode',
}

type BooleanSelectOptions = {
    value: number;
    label: string;
};

export type ControlledFieldProps<T extends FieldValues> = {
    name: string & keyof T;
    control: Control<T, any>;
    label?: string;
    placeholder?: string;
    type?: string;
    fieldType?: FieldTypes;
    fullWidth?: boolean;
    required?: boolean;
    restStyles?: SerializedStyles;
    options?: Array<string | Record<string, string> | BooleanSelectOptions>;
    disabled?: boolean;
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
    id?: string;
    icon?: {
        icon: React.ReactNode;
        onClick: () => void;
    };
    isLoginVariant?: boolean;
};
